<template>
  <div class="link-form">
    <HMModalHeader
      :title="$t('SETTINGS.TITLE.SEND_SMS')"
      @close="$emit('close')"
    />
    <ValidationObserver ref="form" v-slot="{ invalid }">
      <form @submit.prevent="send">
        <div class="form-group">
          <HMTextInput
            type="text"
            rules="required"
            :label="$t('SETTINGS.LABEL.RECIPIENT_PHONE_NUMBER')"
            v-model="phoneNumber"
            name="Recipient's phone number"
          />
          <HMTextarea
            :label="$t('SETTINGS.LABEL.TEXT_TO_SEND')"
            rules="required"
            :maxLength="160"
            v-model="message"
          />
          <HMModalFooter
            :submitButton="$t('GENERAL.BUTTON.SEND')"
            :discardButton="$t('GENERAL.BUTTON.CLOSE')"
            :disabled="invalid || isSending"
            :loading="isSending"
            :formError="formError"
            @close="$emit('close')"
          />
        </div>
      </form>
    </ValidationObserver>
  </div>
</template>

<script>
import Vue from 'vue';
import { ValidationObserver } from 'vee-validate';
import { get, cloneDeep } from 'lodash';
import { mapGetters } from 'vuex';
import { formatObjectForBackend } from '@/core/api/utils/converter';
import { errorToMessage } from '@/core/utils/errors';
import HMTextarea from '@/web/components/common/HMTextarea.vue';

export default Vue.extend({
  name: 'SendSMSModal',
  components: {
    HMTextarea,
    ValidationObserver,
  },
  data() {
    return {
      phoneNumber: null,
      message: null,
      formError: null,
      isSending: false,
    };
  },
  methods: {
    async send() {
      this.isSending = true;
      try {
        const validatedPhone = this.$filterPhone(this.phoneNumber, {
          plus: true,
          brackets: false,
          space: false,
          dash: false,
          areaCode: true,
        });
        try {
          await this.$store.dispatch('setting/sendSMS', {
            phone: validatedPhone,
            message: this.message,
          });
          this.$notify({
            group: 'app',
            type: 'success',
            title: 'SMS successfully delivered',
          });
        } catch (e) {
          this.$notify({
            group: 'app',
            type: 'error',
            title: 'Failed to send SMS',
            text: errorToMessage(e?.response),
            duration: -1,
          });
        }
      } catch (error) {
        this.$notify({
          group: 'app',
          type: 'error',
          title: 'Invalid phone number',
          text:
            'Please include the plus sign, your area code, no brackets, no spaces, no dashes',
        });
      } finally {
        this.isSending = false;
      }
    },
  },
});
</script>

<style lang="scss" scoped>
@import '@/web/styles/components-variables.scss';

.upload-tile {
  border: dashed;
  display: flex;
  border-radius: 0.5rem;
  border-width: 2px;
  border-color: $medium-gray;
  background-color: $light-gray;
}
.photo-preview {
  display: flex;
}
.upload-module {
  display: flex;
  justify-content: center;
  align-items: center;
}
.upload-image {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
